import React from 'react';
import Icon from './Icon';
import { gradientFor } from '../theme/tokens';
import './ui.css';

/** Category shortcut: a rounded gradient square + label, used in the Home rail. */
export default function CategoryChip({ category, onClick }) {
  return (
    <button type="button" className="hive-cat-chip hive-tap hive-focusable" onClick={onClick}>
      <span className="hive-cat-chip-tile" style={{ background: gradientFor(category.id) }}>
        <Icon name={category.icon} size={24} color="#fff" strokeWidth={2.2} />
      </span>
      <span className="hive-cat-chip-label">{category.label}</span>
    </button>
  );
}
